import { useEffect, useRef, useState } from "react";

import delayAwait from "~/util/delayAwait";

const useDelayedState = (
  delay: number,
  trigger: boolean
): { isDelayPassed: boolean; isDelayLoading: boolean } => {
  const [isDelayPassed, setIsDelayPassed] = useState(false);
  const hasTriggered = useRef(false);

  useEffect(() => {
    if (hasTriggered.current) {
      return;
    }

    if (trigger) {
      const start = Date.now();
      setIsDelayPassed(false);

      delayAwait(start, delay).then(() => {
        setIsDelayPassed(true);
      });

      hasTriggered.current = true;
    } else {
      setIsDelayPassed(false);
    }
  }, [delay, trigger]);

  const isDelayLoading = !isDelayPassed && trigger;

  return { isDelayPassed, isDelayLoading };
};

export default useDelayedState;
